<template>

    <div class="error-wrapper">
    	<div class="container">
    	    <h1 class="mb-lg">Oops!</h1>
    	    <p>Something went terribly wrong.</p>
    	    <p>We have unleashed our code monkeys to fix it. Please try again later.</p>
    	</div>
    </div>

</template>
<script>
export default {
    name:'Page404',   
    mounted(){
        this.$store.commit('SET_LAYOUT', 'error-layout');
    }
    
}
</script>